import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import ServerSideDataSource from './ServerSideDataSource';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { useClassificationThresholdContext } from 'contexts/APVendorDBContext/ClassificationThresholdProvider';
import { ApToggleSwitch, colors } from '@alixpartners/ui-components';
import { Wrapper } from './UpdateClassificationFlag.styles';

const UpdateClassificationFlag = props => {
	const { gridRef, onRowSelectionHandler } = props;
	const { thresholdValue } = useClassificationThresholdContext();
	const [columnDefs] = useState([
		{
			headerName: 'Normalized Vendor Name',
			field: 'normalizedVendorName',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'normalizedVendorName',
			filter: 'agTextColumnFilter',
			headerCheckboxSelection: false,
			checkboxSelection: true,
			showDisabledCheckboxes: true,
		},
		{
			headerName: 'AP L1Category',
			field: 'aP_L1Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'aP_L1Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L2Category',
			field: 'aP_L2Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'aP_L2Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L3Category',
			field: 'aP_L3Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'aP_L3Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L4Category',
			field: 'aP_L4Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'aP_L4Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Count',
			field: 'aliasName_count',
			colId: 'aliasName_count',
			filter: false,
		},
		{
			headerName: 'Classification Flag',
			field: 'classificationFlag',
			colId: 'classificationFlag',
			filter: false,
			cellRendererFramework: params => (
				<>
					<ApToggleSwitch
						className="classification_flag"
						disabled
						color={colors.green100}
						defaultChecked={
							parseInt(params.data.classificationFlag) === 1 ? true : false
						}
					/>
				</>
			),
		},
	]);

	const gridStyle = useMemo(
		() => ({
			height: '450px',
			width: '100%',
		}),
		[]
	);

	const [gridOptions] = useState({
		modules: AllModules,
		columnDefs: columnDefs,
		cacheBlockSize: 200,
		maxBlocksInCache: 10,
		enableColResize: true,
		enableSorting: true,
		enableFilter: true,
		rowModelType: 'serverSide',
		floatingFilter: true,
		maxConcurrentDatasourceRequests: 1,
		multiSortKey: 'ctrl',
		enableRangeSelection: true,
		suppressCutToClipboard: true,
	});

	const defaultColDefs = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			editable: false,
		};
	}, []);

	const onGridReady = useCallback(
		params => {
			gridRef.current.api.startEditingCell(params);
			const gridOptionsnew = {
				columnDefs,
				...gridOptions,
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				parseInt(thresholdValue),
				params.columnApi,
				params.api
			);
			params.api.setServerSideDatasource(datasource);
		},
		[columnDefs, gridOptions, thresholdValue, gridRef]
	);

	const isRowSelectable = () => true;

	return (
		<Wrapper>
			<div style={gridStyle} className="ag-theme-balham">
				<AgGridReact
					ref={gridRef}
					modules={AllModules}
					columnDefs={columnDefs}
					cacheBlockSize={200}
					defaultColDef={defaultColDefs}
					maxBlocksInCache={10}
					enableColResize={true}
					enableSorting={true}
					enableFilter={true}
					enableGroupEdit={true}
					rowModelType="serverSide"
					maxConcurrentDatasourceRequests={1}
					multiSortKey="ctrl"
					onGridReady={onGridReady}
					enableRangeSelection={true}
					suppressCutToClipboard={true}
					suppressCellFocus={true}
					rowSelection="multiple"
					// rowMultiSelectWithClick={true}
					onRowSelected={onRowSelectionHandler}
					suppressRowClickSelection={true}
					// isRowSelectable={isRowSelectable}
				/>
			</div>
		</Wrapper>
	);
};

export default UpdateClassificationFlag;
